// normalizers
import commentParseResource from "./parseResource";

export default function commentParseSearch({ data }) {
  return {
    data: (data?.data ?? []).map((comment) =>
      commentParseResource({
        data: comment,
      })
    ),
    meta: {
      total: data?.meta?.nb_results,
    },
  };
}
